import { SimpleConfigBaseFilter } from 'gung-list';
import { MetadataService } from 'gung-standard';

export type HlSalesPersonCodeAccessor<T> = (item: T) => string | undefined | null;

export class HlSalesPersonFilter<T> extends SimpleConfigBaseFilter<T> {
  constructor(
    protected metadataService: MetadataService,
    protected salesPersonCode: HlSalesPersonCodeAccessor<T>
  ) {
    super();
  }

  getName(): string {
    return 'SALJ_SALJARENAMN';
  }

  getOptionIds(item: T): string[] {
    const code = this.salesPersonCode(item);
    if (code === undefined || code === null) {
      return [];
    }
    const key = '' + code;
    if (key.trim() === '') {
      return [];
    }
    return [key];
  }

  getOptionName(key: string): string {
    const salesPersonName = this.metadataService.getMetadataValue('salj', 'saljarenamn', key.toLowerCase());
    return !!salesPersonName ? salesPersonName : key;
  }
}

export type HlSegmentValueAccessor<T> = (item: T) => string | number | undefined | null;

const HL_SEGMENT_NOT_AVAILABLE = 'N/A';

// In case segments should be used elsewhere (especially in the backend) - move it to a backend config.
// Reasoning for keeping it in FE from the start is to enable global changes for all changes without restarting BE 
// or updating all the APs
const HL_SEGMENT_LETTERS: ReadonlyMap<string, string> = new Map([
  ['1', 'A'],
  ['2', 'B'],
  ['3', 'C'],
  ['4', 'D'],
  ['5', 'S'],
  ['6', HL_SEGMENT_NOT_AVAILABLE]
]);

export class HlSegmentFilter<T> extends SimpleConfigBaseFilter<T> {
  constructor(protected segmentValue: HlSegmentValueAccessor<T>) {
    super();
  }

  getName(): string {
    return 'SEGMENT';
  }

  getOptionIds(item: T): string[] {
    const stored = this.segmentValue(item);
    if (stored === undefined || stored === null) {
      return [HL_SEGMENT_NOT_AVAILABLE];
    }

    const key = ('' + stored).trim();
    return [HL_SEGMENT_LETTERS.get(key) ?? HL_SEGMENT_NOT_AVAILABLE];
  }

  getOptionName(key: string): string {
    return key;
  }
}
